
const state = {
  agency_payment_method_id: undefined,
  campaign_id: undefined,
  id: null,
  recipient_address: '',
  recipient_email: '',
  recipient_name: '',
  recipient_phone: '',
  status_id: undefined,
  title: '',
  void: false,
}

export const requiredFields = [
  { key: 'title' },
]

export default state
